<template>

</template>

<script>
  import { Component, Vue } from 'vue-property-decorator';

  @Component
  export default class AdsDetails extends Vue {
  }
</script>

<style scoped>

</style>
